(() => {
  const initialize = root => {
    if (root.dataset.uzHotlineReady === 'true') return;
    root.dataset.uzHotlineReady = 'true';

    const radios = root.querySelectorAll('.uz-contact-hotline__radio');
    const results = root.querySelectorAll('[data-uz-hotline-region]');
    const update = () => {
      const selected = root.querySelector('.uz-contact-hotline__radio:checked')?.value || 'other';
      results.forEach(result => {
        result.hidden = result.dataset.uzHotlineRegion !== selected;
      });
    };

    radios.forEach(radio => radio.addEventListener('change', () => {
      update();
      root.querySelector('.uz-contact-hotline__chooser').open = false;
    }));
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-uz-contact-hotline]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
